/**
 * Fldev Image Uploader - AVEC CROP
 */

document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.fldev-uploader-container');
  if (!container) return;

  const imageUpload = container.querySelector('#fldev-image-upload');
  const uploadButton = container.querySelector('#fldev-upload-button');
  const imagePreview = container.querySelector('#fldev-image-preview');
  const previewImg = container.querySelector('#fldev-preview-img');
  const removeImageBtn = container.querySelector('#fldev-remove-image');
  const imageUrlHidden = container.querySelector('#fldev-image-url');
  const uploadStatus = container.querySelector('#fldev-upload-status');
  
  // Récupérer la forme de crop et le padding
  const cropShape = container.dataset.cropShape || 'square';
  const cropPadding = parseInt(container.dataset.cropPadding || '10');
  const modalConfirmText = container.dataset.modalConfirm || 'Confirmer la sélection';
  const uploadRequired = container.dataset.uploadRequired === 'true';

  // Récupérer le bouton d'ajout au panier
  const addToCartButton = document.querySelector('[name="add"][type="submit"], button[type="submit"][name="add"], .btn[data-add-to-cart], .product-form__cart-submit, #AddToCart, [data-testid="AddToCart"]');
  
  // État initial du bouton si upload obligatoire
  if (uploadRequired && addToCartButton) {
    addToCartButton.disabled = true;
  }

  // Éléments de crop
  let cropModal = document.getElementById('fldev-crop-modal');
  
  // Déplacer la modale dans le body si elle existe
  if (cropModal && cropModal.parentElement !== document.body) {
    document.body.appendChild(cropModal);
  }
  
  // Créer la modale si elle n'existe pas encore
  if (!cropModal) {
    cropModal = createCropModal();
    document.body.appendChild(cropModal);
  }
  
  const cropImage = cropModal.querySelector('#fldev-crop-image');
  const cropSelection = cropModal.querySelector('#fldev-crop-selection');
  const cropConfirm = cropModal.querySelector('#fldev-crop-confirm');
  const cropCancel = cropModal.querySelector('#fldev-crop-cancel');

  let currentFile = null;
  let cropData = { x: 50, y: 50, width: 200, height: 200 };
  let isDragging = false;
  let isResizing = false;
  let resizeHandle = null;
  let startX, startY, startCropX, startCropY, startCropWidth, startCropHeight;

  // Fonction pour mettre à jour l'état du bouton d'ajout au panier
  function updateAddToCartButton(hasImage) {
    if (!uploadRequired || !addToCartButton) return;
    
    addToCartButton.disabled = !hasImage;
  }

  // Créer la modale de crop dynamiquement
  function createCropModal() {
    const modal = document.createElement('div');
    modal.id = 'fldev-crop-modal';
    modal.className = 'fldev-crop-modal';
    modal.innerHTML = `
      <div class="fldev-crop-container">
        <div class="fldev-crop-area">
          <img id="fldev-crop-image" class="fldev-crop-image" src="" alt="Image à recadrer">
          <div class="fldev-crop-overlay">
            <div id="fldev-crop-selection" class="fldev-crop-selection ${cropShape}">
              <div class="fldev-crop-handle nw"></div>
              <div class="fldev-crop-handle ne"></div>
              <div class="fldev-crop-handle sw"></div>
              <div class="fldev-crop-handle se"></div>
            </div>
          </div>
        </div>
        <div class="fldev-crop-buttons">
		  <button type="button" id="fldev-crop-cancel" class="fldev-crop-btn cancel">X</button>
          <button type="button" id="fldev-crop-confirm" class="fldev-crop-btn confirm">${modalConfirmText}</button>
        </div>
      </div>
    `;
    return modal;
  }

  // Configuration BunnyCDN
  const BUNNY_CONFIG = {
    storageZoneName: 'unlocklab-cropper',
    accessKey: '7d9d3866-c29a-4608-b12bf4585fe1-3229-4ac8',
    storageUrl: 'https://storage.bunnycdn.com',
    pullZoneUrl: 'https://unlocklab-cropper.b-cdn.net',
    folder: 'cropper2',
  };

  // Clic sur bouton = clic sur input file
  uploadButton?.addEventListener('click', () => {
    imageUpload?.click();
  });

  // Sélection d'image = ouvrir crop
  imageUpload?.addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith('image/')) return;

    currentFile = file;
    
    // Afficher l'image dans la modale de crop
    const reader = new FileReader();
    reader.onload = (e) => {
      cropImage.src = e.target.result;
      cropModal.style.display = 'flex';
      
      // Désactiver le scroll du body
      document.body.style.overflow = 'hidden';
      
      // Initialiser la zone de crop au centre
      setTimeout(() => {
        const img = cropImage;
        const imgRect = img.getBoundingClientRect();
        
        // Adapter les dimensions selon la forme (plus petites pour rentrer dans l'image)
        let width, height;
        const maxSize = Math.min(imgRect.width, imgRect.height) * 0.6; // 60% de la plus petite dimension
        
        if (cropShape === 'oval') {
          width = maxSize * 0.75; // Ratio 1.5 × 2 cm (75% de largeur)
          height = maxSize;       // Plus haut
        } else {
          // square et circle - même taille
          width = height = maxSize;
        }
        
        cropData.x = (imgRect.width - width) / 2;
        cropData.y = (imgRect.height - height) / 2;
        cropData.width = width;
        cropData.height = height;
        
        updateCropSelection();
      }, 100);
    };
    reader.readAsDataURL(file);
  });

  // Fermer la modale crop
  cropCancel?.addEventListener('click', () => {
    cropModal.style.display = 'none';
    document.body.style.overflow = ''; // Réactiver le scroll
    imageUpload.value = '';
  });

  // Confirmer le crop
  cropConfirm?.addEventListener('click', async () => {
    const croppedCanvas = await cropImageToCanvas();
    const croppedBlob = await new Promise(resolve => {
      croppedCanvas.toBlob(resolve, 'image/jpeg', 0.9);
    });

    // Aperçu local de l'image croppée
    const croppedUrl = URL.createObjectURL(croppedBlob);
    previewImg.src = croppedUrl;
    
    // Appliquer la classe de forme à l'aperçu
    previewImg.className = `preview-${cropShape}`;
    
    imagePreview.style.display = 'block';

    // Upload vers BunnyCDN
    uploadStatus.textContent = '⏳ Upload...';
    try {
      const timestamp = Date.now();
      const fileName = `${timestamp}_cropped.jpg`;
      const filePath = `${BUNNY_CONFIG.folder}/${fileName}`;
      const uploadUrl = `${BUNNY_CONFIG.storageUrl}/${BUNNY_CONFIG.storageZoneName}/${filePath}`;

      const response = await fetch(uploadUrl, {
        method: 'PUT',
        headers: {
          AccessKey: BUNNY_CONFIG.accessKey,
          'Content-Type': 'image/jpeg',
        },
        body: croppedBlob,
      });

      if (response.ok) {
        imageUrlHidden.value = `${BUNNY_CONFIG.pullZoneUrl}/${filePath}`;
        uploadStatus.textContent = '';
        
        // Activer le bouton d'ajout au panier si upload obligatoire
        updateAddToCartButton(true);
      } else {
        uploadStatus.textContent = '❌ Erreur';
      }
    } catch (error) {
      uploadStatus.textContent = '❌ Erreur';
    }

    cropModal.style.display = 'none';
    document.body.style.overflow = ''; // Réactiver le scroll
  });

  // Attacher les événements de crop après création/récupération de la modale
  function attachCropEvents() {
    const cropSel = cropModal.querySelector('#fldev-crop-selection');
    const cropImg = cropModal.querySelector('#fldev-crop-image');
    
    // Fonction commune pour démarrer le drag/resize
    function startDragResize(clientX, clientY, target) {
      const rect = cropSel.getBoundingClientRect();
      const relativeX = clientX - rect.left;
      const relativeY = clientY - rect.top;
      const handleSize = 30; // Zone sensible pour le resize
      
      // Vérifier si c'est un handle ou dans une zone de resize (coins et bords)
      const isInResizeZone = (
        target.classList.contains('fldev-crop-handle') ||
        // Coin bas-droite
        (relativeX > rect.width - handleSize && relativeY > rect.height - handleSize) ||
        // Bord droit
        (relativeX > rect.width - handleSize) ||
        // Bord bas
        (relativeY > rect.height - handleSize)
      );
      
      if (isInResizeZone) {
        isResizing = true;
        resizeHandle = 'se'; // Par défaut on utilise se (Sud-Est)
        console.log('Mode resize activé');
      } else {
        isDragging = true;
        console.log('Mode drag activé');
      }
      
      startX = clientX;
      startY = clientY;
      startCropX = cropData.x;
      startCropY = cropData.y;
      startCropWidth = cropData.width;
      startCropHeight = cropData.height;
    }
    
    // Événements souris
    cropSel?.addEventListener('mousedown', (e) => {
      startDragResize(e.clientX, e.clientY, e.target);
      e.preventDefault();
      e.stopPropagation();
    });
    
    // Événements tactiles (mobile)
    cropSel?.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      startDragResize(touch.clientX, touch.clientY, e.target);
      e.preventDefault();
      e.stopPropagation();
    }, { passive: false });
  }

  // Appeler attachCropEvents après avoir configuré la modale
  attachCropEvents();

  // Fonction commune pour gérer le mouvement
  function handleMove(clientX, clientY) {
    const cropImg = cropModal.querySelector('#fldev-crop-image');
    
    if (isDragging) {
      const deltaX = clientX - startX;
      const deltaY = clientY - startY;
      
      // Ajouter une zone morte (dead zone) de la taille du padding pour éviter le débordement
      const minX = cropPadding;
      const minY = cropPadding;
      const maxX = cropImg.offsetWidth - cropData.width - cropPadding;
      const maxY = cropImg.offsetHeight - cropData.height - cropPadding;
      
      cropData.x = Math.max(minX, Math.min(startCropX + deltaX, maxX));
      cropData.y = Math.max(minY, Math.min(startCropY + deltaY, maxY));
      
      updateCropSelection();
    } else if (isResizing) {
      const deltaX = clientX - startX;
      const deltaY = clientY - startY;
      
      let newWidth, newHeight;
      
      if (cropShape === 'circle') {
        // Pour le cercle : ratio 1:1 (carré)
        const deltaMax = Math.max(deltaX, deltaY);
        newWidth = newHeight = Math.max(50, startCropWidth + deltaMax);
        
        // Vérifier les limites de l'image avec zone morte
        const maxSize = Math.min(
          cropImg.offsetWidth - cropData.x - cropPadding,
          cropImg.offsetHeight - cropData.y - cropPadding
        );
        if (newWidth > maxSize) {
          newWidth = newHeight = maxSize;
        }
      } else if (cropShape === 'oval') {
        // Pour l'ovale : garder le ratio initial (portrait)
        const originalRatio = startCropWidth / startCropHeight;
        newWidth = Math.max(50, startCropWidth + deltaX);
        newHeight = newWidth / originalRatio;
        
        // Vérifier les limites de l'image avec zone morte
        const maxWidth = cropImg.offsetWidth - cropData.x - cropPadding;
        const maxHeight = cropImg.offsetHeight - cropData.y - cropPadding;
        
        if (newWidth > maxWidth) {
          newWidth = maxWidth;
          newHeight = newWidth / originalRatio;
        }
        
        if (newHeight > maxHeight) {
          newHeight = maxHeight;
          newWidth = newHeight * originalRatio;
        }
      } else {
        // Pour le carré : garder le ratio initial
        const originalRatio = startCropWidth / startCropHeight;
        newWidth = Math.max(50, startCropWidth + deltaX);
        newHeight = newWidth / originalRatio;
        
        // Vérifier les limites de l'image avec zone morte
        const maxWidth = cropImg.offsetWidth - cropData.x - cropPadding;
        const maxHeight = cropImg.offsetHeight - cropData.y - cropPadding;
        
        if (newWidth > maxWidth) {
          newWidth = maxWidth;
          newHeight = newWidth / originalRatio;
        }
        
        if (newHeight > maxHeight) {
          newHeight = maxHeight;
          newWidth = newHeight * originalRatio;
        }
      }
      
      cropData.width = newWidth;
      cropData.height = newHeight;
      
      updateCropSelection();
    }
  }

  // Gestion du mouvement - souris
  document.addEventListener('mousemove', (e) => {
    handleMove(e.clientX, e.clientY);
  });

  // Événements tactiles pour mobile
  document.addEventListener('touchmove', (e) => {
    if (isDragging || isResizing) {
      const touch = e.touches[0];
      const cropImg = cropModal.querySelector('#fldev-crop-image');
      
      if (isDragging) {
        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;
        
        // Ajouter une zone morte (dead zone) de la taille du padding pour éviter le débordement
        const minX = cropPadding;
        const minY = cropPadding;
        const maxX = cropImg.offsetWidth - cropData.width - cropPadding;
        const maxY = cropImg.offsetHeight - cropData.height - cropPadding;
        
        cropData.x = Math.max(minX, Math.min(startCropX + deltaX, maxX));
        cropData.y = Math.max(minY, Math.min(startCropY + deltaY, maxY));
        
        updateCropSelection();
      } else if (isResizing) {
        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;
        
        let newWidth, newHeight;
        
        if (cropShape === 'circle') {
          const deltaMax = Math.max(deltaX, deltaY);
          newWidth = newHeight = Math.max(50, startCropWidth + deltaMax);
          
          const maxSize = Math.min(
            cropImg.offsetWidth - cropData.x - cropPadding,
            cropImg.offsetHeight - cropData.y - cropPadding
          );
          if (newWidth > maxSize) {
            newWidth = newHeight = maxSize;
          }
        } else if (cropShape === 'oval') {
          const originalRatio = startCropWidth / startCropHeight;
          newWidth = Math.max(50, startCropWidth + deltaX);
          newHeight = newWidth / originalRatio;
          
          const maxWidth = cropImg.offsetWidth - cropData.x - cropPadding;
          const maxHeight = cropImg.offsetHeight - cropData.y - cropPadding;
          
          if (newWidth > maxWidth) {
            newWidth = maxWidth;
            newHeight = newWidth / originalRatio;
          }
          
          if (newHeight > maxHeight) {
            newHeight = maxHeight;
            newWidth = newHeight * originalRatio;
          }
        } else {
          const originalRatio = startCropWidth / startCropHeight;
          newWidth = Math.max(50, startCropWidth + deltaX);
          newHeight = newWidth / originalRatio;
          
          const maxWidth = cropImg.offsetWidth - cropData.x - cropPadding;
          const maxHeight = cropImg.offsetHeight - cropData.y - cropPadding;
          
          if (newWidth > maxWidth) {
            newWidth = maxWidth;
            newHeight = newWidth / originalRatio;
          }
          
          if (newHeight > maxHeight) {
            newHeight = maxHeight;
            newWidth = newHeight * originalRatio;
          }
        }
        
        cropData.width = newWidth;
        cropData.height = newHeight;
        
        updateCropSelection();
      }
      
      e.preventDefault();
    }
  }, { passive: false });

  // Arrêter le drag
  document.addEventListener('mouseup', () => {
    isDragging = false;
    isResizing = false;
  });

  document.addEventListener('touchend', () => {
    isDragging = false;
    isResizing = false;
  });

  // Mettre à jour la position de la sélection
  function updateCropSelection() {
    const cropSel = cropModal.querySelector('#fldev-crop-selection');
    if (cropSel) {
      cropSel.style.left = cropData.x + 'px';
      cropSel.style.top = cropData.y + 'px';
      cropSel.style.width = cropData.width + 'px';
      cropSel.style.height = cropData.height + 'px';
    }
  }

  // Cropper l'image vers un canvas
  async function cropImageToCanvas() {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const cropImg = cropModal.querySelector('#fldev-crop-image');
    
    // Ajouter le padding à la taille du canvas
    canvas.width = cropData.width + (cropPadding * 2);
    canvas.height = cropData.height + (cropPadding * 2);
    
    const img = new Image();
    img.src = cropImg.src;
    
    return new Promise((resolve) => {
      img.onload = () => {
        // Calculer les ratios
        const scaleX = img.naturalWidth / cropImg.offsetWidth;
        const scaleY = img.naturalHeight / cropImg.offsetHeight;
        
        // Appliquer un masque selon la forme (avec padding)
        if (cropShape === 'circle') {
          // Créer un masque circulaire parfait
          ctx.save();
          ctx.beginPath();
          const radius = Math.min(canvas.width, canvas.height) / 2;
          ctx.arc(canvas.width/2, canvas.height/2, radius, 0, 2 * Math.PI);
          ctx.clip();
        } else if (cropShape === 'oval') {
          // Créer un masque ovale parfait
          ctx.save();
          ctx.beginPath();
          ctx.ellipse(canvas.width/2, canvas.height/2, canvas.width/2, canvas.height/2, 0, 0, 2 * Math.PI);
          ctx.clip();
        }
        
        // Dessiner l'image avec le padding (commencer plus tôt pour inclure la marge)
        ctx.drawImage(
          img,
          (cropData.x - cropPadding) * scaleX,  // Commencer plus tôt (padding négatif)
          (cropData.y - cropPadding) * scaleY,  // Commencer plus tôt (padding négatif)
          (cropData.width + cropPadding * 2) * scaleX,  // Largeur + padding des 2 côtés
          (cropData.height + cropPadding * 2) * scaleY, // Hauteur + padding des 2 côtés
          0,
          0,
          canvas.width,   // Taille finale avec padding
          canvas.height   // Taille finale avec padding
        );
        
        if (cropShape !== 'square') {
          ctx.restore();
        }
        
        resolve(canvas);
      };
    });
  }

  // Supprimer l'image
  removeImageBtn?.addEventListener('click', async () => {
    // Supprimer du CDN si c'est une URL uploadée
    if (imageUrlHidden.value && imageUrlHidden.value.startsWith('http')) {
      try {
        const urlParts = imageUrlHidden.value.replace(BUNNY_CONFIG.pullZoneUrl + '/', '');
        const deleteUrl = `${BUNNY_CONFIG.storageUrl}/${BUNNY_CONFIG.storageZoneName}/${urlParts}`;
        
        await fetch(deleteUrl, {
          method: 'DELETE',
          headers: {
            AccessKey: BUNNY_CONFIG.accessKey,
          },
        });
      } catch (error) {
        console.error('Erreur suppression CDN:', error);
      }
    }

    imageUpload.value = '';
    imagePreview.style.display = 'none';
    previewImg.src = '';
    imageUrlHidden.value = '';
    uploadStatus.textContent = '';
    
    // Désactiver le bouton d'ajout au panier si upload obligatoire
    updateAddToCartButton(false);
  });
});